import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress } from '@mui/material';

function CustomDialog({
    open = true,
    title,
    content,
    onClose,
    onConfirm,
    disableConfirm = false,
    loading = false,
    confirmLabel = 'Confirmar',
    confirmColor = 'primary',
}) {
    return (
        <Dialog open={open} onClose={loading ? undefined : onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>{content}</DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained" color="secondary" disabled={loading}>
                    Cancelar
                </Button>

                <Button
                    onClick={onConfirm}
                    variant="contained"
                    color={confirmColor}
                    disabled={disableConfirm || loading}
                    startIcon={loading ? <CircularProgress size={20} /> : null}
                >
                    {loading ? 'Aguarde...' : confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CustomDialog;
